"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";

function ManagementAccordion({ accordionData }) {
  const [activeItem, setActiveItem] = useState("item-1");
  const [isMobile, setIsMobile] = useState(false);

  // Example: Color "Inspire" and "Vision"
  const highlightWords = ["Manage", "Tenants"];
  const words = accordionData.heading.split(" ");

  // Check if we're on mobile for layout adjustments
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Initial check
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener("resize", checkIfMobile);

    // Cleanup
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  const toggleItem = (itemId) => {
    setActiveItem(activeItem === itemId ? null : itemId);
  };

  return (
    <div className="w-full xl:w-[90%] mx-auto px-4 sm:px-6 lg:px-8 mt-16">
      <h1 className="text-4xl lg:text-5xl xl:text-6xl font-popinsBold text-btnColor text-center mb-6 sm:mb-10 px-2 w-[90%] lg:w-[80%] mx-auto">
        {words.map((word, index) => {
          const cleanWord = word.replace(/[^\w]/g, ""); // remove punctuation
          const isHighlight = highlightWords.includes(cleanWord);
          return (
            <span key={index} className={isHighlight ? "text-themeColor" : ""}>
              {word}{" "}
            </span>
          );
        })}
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
        {/* Mobile: Image appears above accordion when active */}
        {isMobile && activeItem && (
          <div className="w-full h-full bg-gray-100 rounded-lg shadow-md mb-4">
            {/* <AnimatePresence mode="wait">
              {accordionData.data.map(
                (item) =>
                  activeItem === item.id && ( */}
            {/* <motion.div
                      key={item.id}
                      initial={{ opacity: 0, scale: 0.9 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.9 }}
                      transition={{ duration: 0.3 }}
                      className="w-full h-full"
                    > */}
            <div className="w-full h-full">
              <img
                src={accordionData.Images || "/placeholder.svg"}
                alt=""
                className="w-full h-full object-cover"
              />
            </div>
            {/* </motion.div> */}
            {/* )
              )}
            </AnimatePresence> */}
          </div>
        )}

        {/* Accordion */}
        <div className="space-y-2 order-2 lg:order-1">
          <div className="w-full">
            {accordionData.data.map((item, index) => (
              <div
                key={item.id}
                className="border-b border-[#D1D3D4] last:border-b-0"
              >
                <div
                  onClick={() => toggleItem(item.id)}
                  className="flex items-center justify-between py-3 sm:py-4 px-2 cursor-pointer group hover:bg-gray-50 transition-colors rounded-md"
                >
                  <div
                    className={`flex items-center ${
                      activeItem !== item.id
                        ? "text-textColor"
                        : "text-themeColor"
                    }`}
                  >
                    <span className="font-popinsMedium mr-2 text-sm sm:text-base">
                      {index + 1}.
                    </span>
                    <span className="font-popinsMedium text-left text-sm sm:text-lg">
                      {item.title}
                    </span>
                  </div>
                  <motion.div
                    animate={{
                      rotate: activeItem !== item.id ? -45 : 0,
                    }}
                    transition={{ duration: 0.2 }}
                    className={`${
                      activeItem === item.id
                        ? "text-themeColor"
                        : "text-[#D1D3D4]"
                    } flex-shrink-0 ml-2`}
                  >
                    <ArrowRight className="size-4 sm:size-8" strokeWidth={1} />
                  </motion.div>
                </div>
                <AnimatePresence>
                  {activeItem === item.id && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      className="overflow-hidden"
                    >
                      <div className="pb-3 sm:pb-4 pl-2 xl:pr-5 text-xs sm:text-sm text-[#58595B] font-popinsRegular ">
                        {item.content}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>

        {/* Desktop: Image appears beside accordion */}
        {!isMobile && (
          <div className="relative h-full lg:h-full order-1 lg:order-2">
            {/* <AnimatePresence mode="wait">
              {accordionData.data.map(
                (item) =>
                  activeItem === item.id && (
                    <motion.div
                      key={item.id}
                      initial={{
                        opacity: 0,
                        x: 100,
                        scale: 0.9,
                      }}
                      animate={{
                        opacity: 1,
                        x: 0,
                        scale: 1,
                        transition: {
                          duration: 0.5,
                          ease: "easeOut",
                        },
                      }}
                      exit={{
                        opacity: 0,
                        x: -100,
                        scale: 0.9,
                        transition: {
                          duration: 0.3,
                          ease: "easeIn",
                        },
                      }}
                      className="absolute inset-0 flex items-center justify-center"
                    > */}
            {/* <div className="absolute inset-0 flex items-center justify-center"> */}
              <img
                src={accordionData.Images}
                alt=""
                className="w-full h-full object-cover"
              />
            {/* </div> */}
            {/* </motion.div>
                  )
              )}
            </AnimatePresence> */}
          </div>
        )}
      </div>
    </div>
  );
}

export default ManagementAccordion;
